import { useCallback, useMemo, useState } from 'react';
import type { BrandInsightsPageContext } from '@trinity/chat';
import { BrandInsightsModalContext } from '@trinity/chat-components/components/BrandInsights/context.js';
import { ChartFilterProvider } from '@trinity/chat-components/components/Chat/Chat.Chart.Filter.Context.js';
import { ChatPageContextDataContext, DispatchPageContextDataContext } from '@trinity/chat-components/components/Chat/context.js';
import { useAppReadyState } from '@/containers/AppReadyState';
import { ChatWidgetContainer } from '../Chat.Widget';

type Props = {
  children: React.ReactNode;
};

const ChatManagementContainer = (props: Props) => {

  const [contextData, setContextData] = useState<BrandInsightsPageContext.Item>(null);

  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen(prev => !prev), []);

  const enabled = true;

  const modalCtx = useMemo(() => [open, handleToggle] as [boolean, () => void], [open, handleToggle]);

  return (
    <BrandInsightsModalContext.Provider value={modalCtx}>
      <DispatchPageContextDataContext.Provider value={setContextData}>
        <ChatPageContextDataContext.Provider value={contextData}>
          <ChartFilterProvider>
            {enabled && <ChatWidgetContainer />}
            {props.children}
          </ChartFilterProvider>
        </ChatPageContextDataContext.Provider>
      </DispatchPageContextDataContext.Provider>
    </BrandInsightsModalContext.Provider>
  );
};

export const BrandInsightsContainer = (props: Props) => {
  const app = useAppReadyState();

  const initialized = app.initialized && app.authenticated;

  if (!initialized) {
    return (
      <>
        {props.children}
      </>
    );
  }

  return (
    <ChatManagementContainer>
      {props.children}
    </ChatManagementContainer>
  );
};